import React, { useEffect, useState } from "react";
import styles from "./jobDetail.module.css";
import { getJobDetailsById } from "../../Api/commonApi";
import { loader } from "../../store/utilities";
import { useParams } from "react-router-dom";

const JobDetails = () => {
  const paramsId = useParams();
  console.log(paramsId);
  const [jobDetailsData, setJobDetailsData] = useState({});
  const getJobDetailsFunction = async () => {
    loader.start();
    try {
      let response = await getJobDetailsById(paramsId.id).then((res) => {
        return res.data.data;
      });
      console.log(response);
      setJobDetailsData(response);
    } catch (err) {
      console.log(err);
    } finally {
      loader.stop();
    }
  };

  useEffect(() => {
    getJobDetailsFunction();
  }, []);
  return (
    <div className={styles.jobContainer}>
      <div className={styles.header}>
        <div className={styles.jobTitle}>{jobDetailsData.company_name}</div>
        <div className={styles.companyInfo}>
          <span className={styles.companyName}>{jobDetailsData.job_role}</span>
        </div>
        <div className="rating">
          <span>⭐ 3.6&nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp;
          <span>26 Reviews</span>
        </div>
        &nbsp;&nbsp;
        <div className="job-info">
          <span>0 - 1 years&nbsp;&nbsp;&nbsp;&nbsp;</span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>₹50,000 - 70,000 P.A.</span>
          <br />
        </div>
        <div className="job-type">
          <span>Hybrid&nbsp;&nbsp;</span>
          <br />
          <span>
            {" "}
            {`${jobDetailsData?.city} ${jobDetailsData?.state} ${jobDetailsData?.country}`}{" "}
            &nbsp;&nbsp;&nbsp;
            <a href="#" text-decoration="none" className="similar-jobs">
              Send me jobs like this
            </a>
          </span>
          <hr />
        </div>
        <br />
        <div className="additional-info">
          <span>
            Posted:<strong>4 days ago</strong>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <span>
            Openings:<strong>50</strong>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <span>
            Applicants:<strong>1150</strong>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>

          <span className="actions">
            <button
              style={{
                backgroundColor: "blue",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
              }}
            >
              Register to apply
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button
              style={{
                backgroundColor: "blue",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
              }}
            >
              Login to apply{" "}
            </button>
          </span>
        </div>
        <br />
      </div>

      {/* ...........////////////////////////////////////////////////////////////////////////////////////////////////////////////......................................... */}

      <div className={styles.jobDescription}>
        <p>
          <b>Job Description</b>
        </p>
        <div
          dangerouslySetInnerHTML={{ __html: jobDetailsData?.description }}
        />
        <br />

        <div >
          <b> Requirements:</b>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: jobDetailsData?.requirements }}
        />
        <br />
        <div className={styles.skill}>
          <button
            style={{
              backgroundColor: "none",
              color: "black",
              padding: "10px 20px",
              border: "none",
              borderRadius: "25px",
            }}
          >
            {jobDetailsData?.skill}
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobDetails;
